module.exports = __webpack_public_path__ + "img/internet.6fc28704.png";